// eslint-disable-next-line no-unused-vars
import { IModel } from '@src/js/separate-logic/interface/IModel';
import { getIframeSrc } from './utils';
import type { AddonWhitelist } from '@tencent/td-addon-sdk-docs';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

export default class RenderIframeModel implements IModel {
    private loadCover: boolean;
    private inCurrentSlide: boolean;
    private needEvent: boolean;
    private iframeSrc: string;
    private snapshotUrl: string | null;
    private isVideoType: boolean;
    private addonName: string | null;
    private addonIcon: string | null;
    private miniAppRenderWhitelist: AddonWhitelist[] | null;
    public initModel(props) {
        this.loadCover = this.getInitLoadCover(props);
        this.inCurrentSlide = false;
        this.needEvent = false;
        this.iframeSrc = getIframeSrc(props);
        this.snapshotUrl = null;
        this.isVideoType = false;
        this.addonName = null;
        this.addonIcon = null;
        this.miniAppRenderWhitelist = null;
    }
    private getInitLoadCover = (props): boolean => !((props.isPlayState && browser.isMiniProgram)
        || props.mobileEditMode?.());
}
